<template>
	<view class="store-info-page">
		<view class="top-gradient"></view>
		<view class="form-card">
			<text class="page-title">门店信息</text>

			<view class="form-group">
				<text class="label">门店名称</text>
				<input v-model="form.name" class="text-input align-left" type="text" placeholder="请输入门店名称" placeholder-style="color: #B2B2B2;" />
			</view>

			<view class="divider"></view>

			<view class="form-group textarea-group">
				<text class="label">门店介绍</text>
				<input v-model="form.intro" class="text-input align-left" type="text" placeholder="请输入门店介绍" placeholder-style="color: #B2B2B2;" />
			</view>

			<view class="divider"></view>

			<view class="form-group switch-group">
				<view class="label-row">
					<text class="label">是否全天营业</text>
					<text class="required">*</text>
				</view>
				<view class="switch-row">
					<view class="switch-pill" :class="{ active: !form.fullTime }" @tap="form.fullTime = false">是</view>
					<view class="switch-pill" :class="{ active: form.fullTime }" @tap="form.fullTime = true">否</view>
				</view>
			</view>

			<view class="form-group">
				<view class="label-row">
					<text class="label">营业时间</text>
					<text class="required">*</text>
				</view>
				<input v-model="form.businessHours" class="text-input align-left" type="text" placeholder="必填，请输入门店营业时间" placeholder-style="color: #B2B2B2;" />
			</view>

			<view class="divider"></view>

			<view class="form-group">
				<text class="label">寄存类型</text>
				<input v-model="form.storageType" class="text-input align-left" type="text" placeholder="请输入可寄存类型" placeholder-style="color: #B2B2B2;" />
			</view>

			<view class="divider"></view>

			<view class="form-group">
				<view class="label-row">
					<text class="label">配送范围</text>
					<text class="required">*</text>
				</view>
				<view class="input-with-unit">
					<input v-model="form.deliveryRange" class="text-input" type="digit" placeholder="必填，请输入" placeholder-style="color: #B2B2B2;" />
					<text class="unit-text" style="font-size: 28rpx;">公里</text>
				</view>
			</view>

			<view class="divider"></view>

			<view class="form-group textarea-group last-group">
				<view class="label-row">
					<text class="label">收费标准</text>
					<text class="required">*</text>
				</view>
				<textarea v-model="form.chargeRule" class="text-area charge-area" placeholder="必填，请输入门店收费标准" placeholder-style="color: #B2B2B2;" auto-height></textarea>
			</view>
		</view>

		<view class="save-wrap">
			<view class="save-btn">保存</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					name: '',
					intro: '',
					fullTime: true,
					businessHours: '',
					storageType: '',
					deliveryRange: '',
					chargeRule: ''
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.store-info-page {
		position: relative;
		height: 482rpx;
		background: #f2fbff;
		padding: 20rpx 30rpx;
		box-sizing: border-box;
	}

	.top-gradient {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 220rpx;
		background: linear-gradient(180deg, #bfeefe 0%, #ebfaff 58%, #f2fbff 100%);
		z-index: 0;
	}

	.form-card {
		position: relative;
		z-index: 1;
		background: #ffffff;
		border-radius: 20rpx;
		padding: 30rpx;
		box-sizing: border-box;
		box-shadow: 0rpx 2rpx 20rpx 0rpx rgba(0,0,0,0.08);
	}

	.page-title {
		display: block;
		font-weight: 600;
		font-size: 36rpx;
		color: #222222;
	}

	.form-group {
		padding: 30rpx 0;
		box-sizing: border-box;
	}

	.form-group.textarea-group {
		padding-bottom: 10rpx;
	}

	.last-group {
		padding-bottom: 22rpx;
	}

	.label,
	.required,
	.unit-text {
		font-size: 30rpx;
	}

	.label {
		font-weight: 500;
		font-size: 30rpx;
		color: #222222;
	}

	.label-row {
		display: flex;
		align-items: center;
	}

	.required {
		margin-left: 2rpx;
		color: #ff4d4f;
		line-height: 1;
	}

	.text-input {
		width: 100%;
		height: 48rpx;
		margin-top: 14rpx;
		font-weight: 400;
		font-size: 30rpx;
		color: #111111;
		background: transparent;
	}

	.text-input.align-left {
		text-align: left;
	}

	.placeholder {
		font-size: 28rpx;
		color: #c4c9d1;
	}

	.text-area {
		width: 100%;
		min-height: 56rpx;
		margin-top: 14rpx;
		font-size: 28rpx;
		line-height: 1.5;
		color: #666666;
		background: transparent;
	}

	.charge-area {
		min-height: 140rpx;
	}

	.divider {
		height: 1rpx;
		background: #f0f1f4;
	}

	.switch-group {
		padding-bottom: 18rpx;
	}

	.switch-row {
		margin-top: 30rpx;
		display: flex;
		gap: 18rpx;
	}

	.switch-pill {
		width: 208rpx;
		height: 72rpx;
		border-radius: 36rpx;
		background: #eeeeee;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 400;
		font-size: 30rpx;
		color: #333333;
	}

	.switch-pill.active {
		background: #10B2FA;
		color: #ffffff;
	}

	.input-with-unit {
		margin-top: 14rpx;
		display: flex;
		align-items: center;
	}

	.input-with-unit .text-input {
		margin-top: 0;
		flex: 1;
	}

	.unit-text {
		margin-left: 12rpx;
		color: #666666;
		flex-shrink: 0;
	}

	.save-wrap {
		margin-top: 30rpx;
		padding-bottom: calc(env(safe-area-inset-bottom) + 30rpx);
	}

	.save-btn {
		height: 88rpx;
		background: #10B2FA;
		border-radius: 44rpx;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 500;
		font-size: 32rpx;
		color: #FFFFFF;
	}
</style>
